export const accordion = () => {
    window.addEventListener('click', e => {
        if (e.target.closest('[js-tippy]')) return;
        if (!e.target.closest('[js-accordion-button]')) return;
        const accordionElement = e.target.closest('[js-accordion-element]');
        const isActive = accordionElement.classList.contains('-active');
        const parent = e.target.closest('[js-accordion-elements]');
        const isAllOpenedPossible =
            parent?.getAttribute('js-all-opened') != null;

        if (parent) {
            if (!isAllOpenedPossible) {
                parent
                    .querySelectorAll('[js-accordion-element]')
                    .forEach(el => {
                        el.classList.remove('-active');
                    });
            }

            if (!isActive) {
                accordionElement.classList.add('-active');
            } else {
                accordionElement.classList.remove('-active');
            }
        }

        // dispatch custom event
        window.dispatchEvent(
            new CustomEvent('accordion:change', {
                detail: {
                    opened: !isActive,
                    element: accordionElement,
                },
            })
        );
    });
};
